<template>
  <gg-card>
    <gg-card-header>
      Migration Early Start
    </gg-card-header>
    <gg-card-text>
      <p class="mb-1">
        Your migration can now be started on your own schedule. Click the button below to queue your migration.
      </p>
      <p class="mb-1">
        Make sure no website or database changes occur until your migration is completed and you have allowed
        time for DNS propagation.
      </p>
      <p>
        If you do not start your migration early, your migration will be processed automatically
        on {{ migration.scheduled_for }}.
      </p>
      <div class="flex-column gap-1">
        <v-checkbox v-model="confirmation">
          <template v-slot:label>
            I confirm I am ready to start the migration. I understand the migration will be processed
            immediately and that I should make no changes during the migration.
          </template>
        </v-checkbox>
        <gg-btn
          :disabled="!confirmation"
          :loading="loading"
          @click="startMigration">
          Start Migration
        </gg-btn>
      </div>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'

export default {
  name: 'MigrationStartCard',
  props: {
    migration: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      confirmation: false
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async startMigration () {
      this.loading = true
      try {
        const response = await amapi.makecall('migration_early_start', { id: this.migration.id })
        this.reportSuccess(response.resultmsg)
        this.$emit('get-migration-data')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
